
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/sort-comp */
/* eslint-disable react/no-did-update-set-state */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import icon from '../../icons/Document.png';
import SectionHeader from '../../components/sectionHeader';
import Button from '../../components/button';
import Modal from '../../components/modal';
import Loading from '../../components/loading';
import Table from './components/Table';
import DocumentForm from './components/Documents';
import { fetchDocuments, createDocument, updateDocument, getDocusign, fetchDocumentsTypes, getDocSignedUrl } from './redux/actions';
import { GetFileName, S3Uploads } from '../services';
import styles from './document.module.scss';
import CommentContainer from '../../components/commenContainer';

class DocumentList extends Component {
  state = {
    showIn: false,
    showErrors: false,
    info: {},
    fieldErrors: {
      document_type: true,
      description: true,
      valid_date: true
    },
    loadingStatus: false,
    showComments: false,
    commentsInfo: ''
  }

  componentDidMount() {
    const { actionFetchDocuments, actionGetDocusign, actionFetchDocumentsTypes } = this.props;
    if (this.props.location) {
      const search = new URLSearchParams(this.props.location.search);
      const event = search.get('event');
      const envelope_id = search.get('envelope_id');
      actionFetchDocuments();
      actionFetchDocumentsTypes();
      if (event && event === 'signing_complete') {
        this.setState({
          loadingStatus: true
        });
        actionGetDocusign(envelope_id, 'envelop');
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { createDocumentAction, actionFetchDocuments, getDocusignAction, updateDocuments, history, homeTabTile,
    getDocUrlAction, docSignUrlData } = this.props;
    if (prevProps.createDocumentAction.success === false && createDocumentAction.success === true) {
      actionFetchDocuments();
      if (homeTabTile) updateDocuments();
      this.setState({
        info: {},
        showIn: false,
        fieldErrors: {
          document_type: true,
          valid_date: true,
          description: true
        },
        showErrors: false,
        loadingStatus: false
      });
    }

    if (getDocusignAction && getDocusignAction.success) {
      history.push('/document');
      window.location.reload();
    }
    if (prevProps.getDocUrlAction.success === false && getDocUrlAction.success === true) {
      if (docSignUrlData?.docusign_signed_url?.url) {
        window.open(docSignUrlData?.docusign_signed_url?.url, '_blank');
        this.setState({
          loadingStatus: false
        });
      } else {
        actionFetchDocuments();
        this.setState({ loadingStatus: false });
      }
    }
  }

  handleAnswerChanged = (answer, id) => {
    this.setState(prevState => ({
      info: {
        ...prevState.info,
        [id]: answer
      }
    }));
  }

  handleFieldErrorChanged = (id, value) => {
    this.setState(prevState => ({
      fieldErrors: {
        ...prevState.fieldErrors,
        [id]: value
      }
    }));
  }

  handleCancel = () => {
    this.setState({
      showIn: false,
      info: {},
      fieldErrors: {
        document_type: true,
        description: true,
        valid_date: true
      },
      showErrors: false
    });
  }

  handleNew = () => {
    this.setState({
      showIn: true,
      info: {},
      fieldErrors: {
        document_type: true,
        description: true,
        valid_date: true
      },
      showErrors: false
    });
  }

  handleEdit = (e) => {
    this.setState({
      info: {
        id: e.id,
        document_type: e.document_type,
        valid_date: e.valid_date,
        description: e.description,
        attachments: e.attachments,
        portal_options: e.portal_options
      },
      fieldErrors: {
        document_type: e.document_type === null,
        valid_date: e.valid_date === null,
        description: e.description === null
      },
      showIn: true,
      showErrors: false
    });
  }

  handleSave = async () => {
    const { info } = this.state;
    const { actionUpdateDocument } = this.props;
    const sendResponse = {};
    const { attachments, valid_date, description, removedAttachments } = info;
    if (valid_date) {
      sendResponse.valid_date = valid_date || '';
      this.setState({ loadingStatus: true });
      const entity = 'tenant_lease_documents';
      const newAttachments = [];
      if (attachments && attachments.length > 0) {
        attachments.forEach((e) => {
          if (!e.id) {
            newAttachments.push(e);
          }
        });
      }
      let fileIds = '';
      if (newAttachments.length > 0) {
        fileIds = await this.getFileNames(newAttachments.length);
      }
      const list = [];
      if (fileIds) {
        await this.doS3Upload(newAttachments, fileIds, entity)
          .then(() => {
            fileIds.filename.forEach((id) => {
              list.push(id.toString());
            });
          });
      }
      if (list.length > 0) sendResponse.attachments = list;
      if (removedAttachments?.length > 0) sendResponse.removedAttachments = removedAttachments;
      sendResponse.description = description || '';
      if (info.id && Object.keys(sendResponse)?.length > 0) {
        sendResponse.status = null;
        sendResponse.portal_options = {
          ...info.portal_options,
          updated_source: 'portal'
        };
        actionUpdateDocument(info.id, sendResponse);
      } else {
        this.setState({ loadingStatus: false, showIn: false });
      }
    } else {
      this.setState({
        showErrors: true
      });
    }
  }

  getFileNames = async (count) => {
    const response = await GetFileName.getUploadFileName(count);
    return response;
  };

  doS3Upload = async (files, fileIds, entity) => {
    const response = await S3Uploads.uploadFiles(files, fileIds.filename, entity);
    return response;
  };

  handleReview = (id) => {
    const { actionGetDocSignedUrl } = this.props;
    this.setState({
      loadingStatus: true
    });
    actionGetDocSignedUrl(id);
  };

  sortComments = comments => comments?.length > 0 && comments.sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at)
  );

  render() {
    const { documentList, homeTabTile, documentsList, documentTypes, document_types, profile } = this.props;
    const { showIn, info, showErrors, loadingStatus, showComments, commentsInfo } = this.state;
    const tableInfo = homeTabTile ? documentsList : documentList?.documents;
    return (
      <>
        {!homeTabTile && <>
          <SectionHeader
            icon={icon}
            translationID="documents.title"
            defaultTitle="Lease Documents"
          />
          <div style={{ display: 'flex' }} className={styles.toolbar}>
            <div className={styles.counter}>
              <div className={styles.count}>
                <FormattedMessage id="document.list.all" defaultMessage="All Documents " />
              </div>
            </div>
          </div>
                         </>}
        <Loading loadingStatus={loadingStatus} />
        <div style={{ padding: !homeTabTile && '0 5%' }}>
        <div className={homeTabTile ? styles.removeMargin : styles.docContainer} style={{ border: '1px solid #ddd', maxWidth: '100%' }}>
          {documentList && (
            <Table info={tableInfo} handleEdit={this.handleEdit} profile={profile}
              portal_all_required={documentList?.portal_all_required}
              groupByDocuments handleReview={this.handleReview} handleViewComments={e => this.setState({ showComments: true, commentsInfo: e })}
            />
          )}
          <Modal showIn={showIn} onClose={this.handleCancel} style={{ width: '806px', height: '40%' }}>
            <div className={styles.newField}>
              <div className={styles.title}>
                {info.id && (
                  <FormattedMessage tagName="h5" id="tenant.detail.edit_document_title"
                    defaultMessage="Edit Document"
                  />
                )}
              </div>
              <div className={styles.content}>
                <DocumentForm
                  info={info}
                  handleAnswerChanged={this.handleAnswerChanged}
                  showFormErrors={showErrors}
                  handleFieldErrorChanged={this.handleFieldErrorChanged}
                  documentTypes={document_types || documentTypes?.document_types}
                />
              </div>
              <div className={styles.footer}>
                <Button action="tertiary" translationID="inspections.new.cancelBtn" defaultText="Cancel"
                  onClick={this.handleCancel}
                />
                <div className={styles.modalBtnGroup}>
                  <Button action="primary" translationID="inspections.new.addBtn" defaultText="Add"
                    onClick={this.handleSave}
                  />
                </div>
              </div>
            </div>
          </Modal>
          <Modal showIn={showComments} onClose={() => this.setState({ showComments: false, commentsInfo: '' })} width="806px" closeIcon>
            <div className={styles.newField}>
              <div className={styles.title}>
                <FormattedMessage tagName="h5" id="tenant.detail.view.comments"
                  defaultMessage={`View Comments (${commentsInfo?.document_info?.document_comments?.length || 0})`}
                />
              </div>
              <div className={styles.content}>
                <CommentContainer
                  comments={this.sortComments(commentsInfo?.document_info?.document_comments) || []}
                  driverPermit />
              </div>
            </div>
          </Modal>
        </div>
        </div>
      </>
    );
  }
}

DocumentList.propTypes = {
  history: PropTypes.shape({}).isRequired,
  actionFetchDocuments: PropTypes.func.isRequired,
  actionCreateDocument: PropTypes.func.isRequired,
  actionUpdateDocument: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  documentList: state.document.documentList,
  createDocumentAction: state.document.createDocumentAction,
  getDocusignAction: state.document.getDocusignAction,
  documentTypes: state.document.documentTypes,
  getDocUrlAction: state.document.getDocUrlAction,
  docSignUrlData: state.document.docSignUrlData,
  profile: state.auth.profile
});

const mapDispatchToProps = dispatch => ({
  actionFetchDocuments: () => {
    dispatch(fetchDocuments());
  },
  actionFetchDocumentsTypes: () => {
    dispatch(fetchDocumentsTypes());
  },
  actionCreateDocument: (data) => {
    dispatch(createDocument(data));
  },
  actionUpdateDocument: (id, data) => {
    dispatch(updateDocument(id, data));
  },
  actionGetDocusign: (id, get_by) => {
    dispatch(getDocusign(id, get_by));
  },
  actionGetDocSignedUrl: (id) => {
    dispatch(getDocSignedUrl(id));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(DocumentList);
